import React from 'react';

export default function EmployeeAdvancedSearchModal({ open, onClose, advFields, onChange, onSubmit, onReset }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-start justify-center z-50 font-sans overflow-y-auto overscroll-contain py-4 px-2 sm:items-center sm:py-6">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full max-h-[min(90vh,calc(100dvh-2rem))] overflow-y-auto overscroll-contain min-w-0 relative mx-4 my-auto">
        <button
          className="absolute top-2 right-6 text-md font-bold text-gray-500 hover:text-gray-700 transition-all duration-300"
          onClick={onClose}
        >
          x
        </button>
        <div className="flex flex-col items-center mb-4">
          {/* SVG icon */}
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="url(#grad1)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <defs>
              <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#674936" />
                <stop offset="100%" stopColor="#a2a2a2ff" />
              </linearGradient>
            </defs>
            <line x1="6" y1="3" x2="6" y2="21" />
            <circle cx="6" cy="7" r="2" />
            <line x1="12" y1="3" x2="12" y2="21" />
            <circle cx="12" cy="17" r="2" />
            <line x1="18" y1="3" x2="18" y2="21" />
            <circle cx="18" cy="12" r="2" />
          </svg>
          <h2 className="text-xl font-semibold mt-2 mb-1">Advanced Search</h2>
        </div>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-2">Status:</label>
            <select name="status" value={advFields.status} onChange={onChange} className="w-full bg-white text-[0.9rem] border rounded px-2 py-1 font-sans h-[42px] rounded-lg">
              <option value="">Select</option>
              <option value="Active">Active</option>
              <option value="On Leave">On Leave</option>
              <option value="Exited">Exited</option>
            </select>
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium">Employee No:</label>
            <input name="employee_no" value={advFields.employee_no} onChange={onChange} className="w-full font-sans border h-[42px] rounded-lg text-[0.9rem] px-2 py-1" placeholder="Enter employee number" />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium">Name:</label>
            <input name="name" value={advFields.name} onChange={onChange} className="w-full border font-sans text-[0.9rem] px-2 py-1 h-[42px] rounded-lg" placeholder="Enter name" />
          </div>
          <div className="flex justify-between mt-4">
            <button type="button" className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 transition-all duration-300" onClick={onReset}>Cancel</button>
            <button
              type="submit"
              className="px-4 py-2 rounded text-white bg-gradient-to-r from-[#674936] to-gray-500 hover:from-[#674938] hover:to-gray-600 transition-all duration-300"
            >
              Search
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 